if (!customElements.get('rotterdam-store-toggle')) {
  customElements.define('rotterdam-store-toggle', class extends HTMLElement {
    connectedCallback() {
      this.unsubscribe = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, ({responseText}) => {
        const doc = new DOMParser().parseFromString(responseText, 'text/html');
        const fresh = doc.getElementById(this.id);
        if (fresh) this.innerHTML = fresh.innerHTML;
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  });
}
